import React from 'react';
import Stack from '@mui/material/Stack';
import { useFieldHelper } from 'framework/ui/field';
import { Typography } from '@mui/material';
import { RetentionRiskIssue } from '../../types';

const IssuesEmployeeDashboardFiled = () => {
  const { getValue } = useFieldHelper<RetentionRiskIssue[]>({ source: 'retentionRiskIssues' });
  const issues = getValue();

  return (
    <Stack>
      <Typography variant="body1" color="error">
        {issues[0]?.description || ''}
      </Typography>
      {issues.length > 1 && (
        <Typography variant="caption" color="error">{`...and ${issues.length - 1} more`}</Typography>
      )}
    </Stack>
  );
};

export default IssuesEmployeeDashboardFiled;
